import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const SpinnerWrapperStyled = styled.div`
  position: relative;
  width: 100%;
  height: 40rem;
  margin: 0 auto;
`;

export const StatisticsBlockStyled = styled.ul`
  list-style: none;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8rem;
  padding: 0;
`;

export const StatisticsCardStyled = styled.li`
  background-color: ${colors.neutral.white};
  width: 22%;
  border-radius: 10px;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${colors.neutral[900]};
  padding: 0.5rem;
  height: 10rem;
`;

export const ActionButtonStyled = styled(Button)`
  min-width: 24rem;
`;

export const ImportErrorsCardStyled = styled(StatisticsCardStyled)`
  color: ${colors.red[600]};
`;

export const FilterCardTitleStyled = styled.h6`
  font-size: 1.8rem;
  line-height: 2.4rem;
  font-weight: 500;
  margin: 0;
  text-align: center;
`;

export const FilterCardQuantityStyled = styled.p`
  font-size: 2.6rem;
  line-height: 3.4rem;
  font-weight: 700;
  margin: 0;
`;

export const ButtonsWrapperStyled = styled.div`
  display: flex;
  margin-bottom: 5rem;
  justify-content: center;
  gap: 2.4rem;
`;

export const SubmitButtonDisclaimerStyled = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
`;
